var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo1StHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.283,
    cy: 2.14234,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8728,
    cy: 5.41383,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.1428,
    cy: 13.9998,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.8728,
    cy: 22.5867,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.283,
    cy: 25.8572,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.69801,
    cy: 22.5867,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.42652,
    cy: 13.9998,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.28834,
    cy: 5.41383,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4226,
    cy: 8.27515,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4226,
    cy: 11.1375,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.55836,
    cy: 11.1375,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0081,
    cy: 11.1375,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.55836,
    cy: 13.9998,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0081,
    cy: 13.9998,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.55836,
    cy: 16.8621,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.0081,
    cy: 16.8621,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4226,
    cy: 13.9998,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4226,
    cy: 16.8621,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.4226,
    cy: 19.7253,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.283,
    cy: 8.27515,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.283,
    cy: 11.1375,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.283,
    cy: 13.9998,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.283,
    cy: 16.8621,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.283,
    cy: 19.7253,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1477,
    cy: 8.27515,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1477,
    cy: 11.1375,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1477,
    cy: 13.9998,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1477,
    cy: 16.8621,
    r: 1.42652,
    fill: "#E7EAE9"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1477,
    cy: 19.7253,
    r: 1.42652,
    fill: "#E7EAE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1StHalf);
export default __webpack_public_path__ + "static/media/logo1st-half.acaea1c5daa4066216d85a6b26e87886.svg";
export { ForwardRef as ReactComponent };